import { render, staticRenderFns } from "./StandmansTable.vue?vue&type=template&id=1bde8c96&"
import script from "./StandmansTable.vue?vue&type=script&lang=ts&"
export * from "./StandmansTable.vue?vue&type=script&lang=ts&"
import style0 from "./StandmansTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
